import { Vue } from 'vue-property-decorator';
import { CreateElement } from 'vue';

export const ProgressButton = Vue.extend({
    functional: true,

    props: {
        progressText: {
            type: String,
            default: () => 'Loading',
        },
        progress: Boolean,
        disabled: Boolean,
        tag: {
            type: String,
            default: 'b-button',
        },
    },

    render(h: CreateElement, context) {
        const { props } = context

        if (!props.progress) {
            if (props.disabled) {
              Object.assign(context.data.attrs, { disabled: true })
            }
            return h(props.tag, context.data, context.children)
        }

        // tslint:disable-next-line: no-string-literal
        const renderText = context['_v'];
        const progressText = renderText(props.progressText)
        const spinner = h('b-spinner', {
            props: {
                small: true,
                type: 'border',
            },
            staticClass: 'mr-2',
            style: {
              verticalAlign: 'sub',
            }
        })

        Object.assign(context.data.attrs, { disabled: true })

        return h('b-button', context.data, [
            spinner,
            progressText,
        ])
    },
});
